import { ChatSession } from "../core/types";
import { getStrings } from "../core/i18n";

function sanitizeFileName(name: string): string {
  return name.replace(/[\\/:*?"<>|]/g, "_").trim() || "chat";
}

// A manual, permanent backup independent of local storage's durability.
// Speaker labels are literal "**You:**" / "**Assistant:**" headers, not just visual styling —
// this file is meant to be legible both to a human and, per its main intended use, pasted into
// a *different* AI chat to continue the conversation with context. Unambiguous text labels
// survive that round-trip; anything relying on layout/color wouldn't.
export function buildExportMarkdown(session: ChatSession, providerName: string): string {
  const s = getStrings();
  const lines: string[] = [
    `# ${session.title}`,
    "",
    `${s.exportFile.provider} ${providerName} · ${s.exportFile.model} ${session.model}`,
    `${s.exportFile.exported} ${new Date().toLocaleString()}`,
    "",
    "---",
    "",
  ];
  for (const m of session.messages) {
    lines.push(m.role === "user" ? s.exportFile.you : s.exportFile.assistant);
    lines.push("");
    lines.push(m.content);
    lines.push("");
  }
  return lines.join("\n");
}

export function exportSessionToFile(session: ChatSession, providerName: string): void {
  const text = buildExportMarkdown(session, providerName);
  const blob = new Blob([text], { type: "text/markdown;charset=utf-8" });
  const fileName = `${sanitizeFileName(session.title)}.md`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
